import React from 'react';
import UserComponent from "../components/userComponent";
import App from "../App";

const UserPage = () => {
    return (
        <>
            <App/>
            <UserComponent />
        </>
    );
};

export default UserPage;